import React from 'react';
const NotesIcon = (props) => {
  return (
    <svg className="cursor" onClick={props.handleClick} xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 11.001 14.667">
      <path id="file-lines-solid" d="M7.334,0V3.667H11ZM6.417,3.667V0H1.375A1.375,1.375,0,0,0,0,1.375V13.292a1.375,1.375,0,0,0,1.375,1.375h8.25A1.375,1.375,0,0,0,11,13.292V4.584H7.36A.922.922,0,0,1,6.417,3.667Zm1.375,8.25H3.209a.458.458,0,0,1,0-.917H7.792a.458.458,0,1,1,0,.917Zm0-1.833H3.209a.458.458,0,1,1,0-.917H7.792a.458.458,0,1,1,0,.917ZM8.25,7.792a.46.46,0,0,1-.458.458H3.209a.458.458,0,0,1,0-.917H7.792A.46.46,0,0,1,8.25,7.792Z" fill={props.color ? props.color : "#393e46"} />
    </svg>
  )
}

export default NotesIcon;